import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"
import slugify from "slugify"

const SummitSpeakersBlock = ({
  key,
  title=null,
  subTitle=null,
  speakers=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      <div className="col-12 summit-speakers-block">
        <div className="container">
          <div className="row flex-wrap jcc">
            <div className="col-12 text-center">
              {title &&
                <h2 className={ `content-title center ${subTitle ? "orange-dash" : "mb4"}` }>{ htmlDecode(title) }</h2>
              }
              {subTitle &&
                <div className="section-content" dangerouslySetInnerHTML={{ __html: subTitle }} />
              }
            </div>
            {speakers && speakers.map((speaker, index) => (
              <div className="col-6 col-md-3 speaker-block">
                {speaker.speakerBio &&
                  <a className="speaker-block__link" data-toggle="modal" data-target={ `#speaker-${slugify(speaker.speakerName, {remove: /[*+~.,()'"!:@]/g})}-${index}` }>
                    {speaker.speakerImage &&
                      <div className="speaker-block__img">
                        {speaker.speakerImage?.formats?.medium &&
                          <img src={speaker.speakerImage.formats.medium.url.includes(cdnUrl) ? speaker.speakerImage.formats.medium.url : cdnUrl + speaker.speakerImage.formats.medium.url} alt={ speaker.speakerImage?.alternativeText } />
                        }
                        {!speaker.speakerImage?.formats?.medium &&
                          <img src={speaker.speakerImage.url.includes(cdnUrl) ? speaker.speakerImage.url : cdnUrl + speaker.speakerImage.url} alt={ speaker.speakerImage?.alternativeText } />
                        }
                      </div>
                    }
                    <div className="speaker-block__info">
                      {speaker.speakerName &&
                        <h2 className="speaker-block__title">{ htmlDecode(speaker.speakerName) }</h2>
                      }
                      {speaker.speakerShortDescription &&
                        <h3 className="speaker-block__subtitle">{ htmlDecode(speaker.speakerShortDescription) }</h3>
                      }
                      <span className="button">View Bio</span>
                    </div>
                  </a>
                }
                {!speaker.speakerBio &&
                  <div className="speaker-block__link">
                    {speaker.speakerImage &&
                      <div className="speaker-block__img">
                        {speaker.speakerImage?.formats?.medium &&
                          <img src={speaker.speakerImage.formats.medium.url.includes(cdnUrl) ? speaker.speakerImage.formats.medium.url : cdnUrl + speaker.speakerImage.formats.medium.url} alt={ speaker.speakerImage?.alternativeText } />
                        }
                        {!speaker.speakerImage?.formats?.medium &&
                          <img src={speaker.speakerImage.url.includes(cdnUrl) ? speaker.speakerImage.url : cdnUrl + speaker.speakerImage.url} alt={ speaker.speakerImage?.alternativeText } />
                        }
                      </div>
                    }
                    <div className="speaker-block__info">
                      {speaker.speakerName &&
                        <h2 className="speaker-block__title">{ htmlDecode(speaker.speakerName) }</h2>
                      }
                      {speaker.speakerShortDescription &&
                        <h3 className="speaker-block__subtitle">{ htmlDecode(speaker.speakerShortDescription) }</h3>
                      }
                    </div>
                  </div>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        {speakers && speakers.map((speaker, index) => (
          <div className="modal fade speaker-block-modal-block" id={ `speaker-${slugify(speaker.speakerName, {remove: /[*+~.,()'"!:@]/g})}-${index}` } tabindex="-1" role="dialog" aria-labelledby={ `speaker-${slugify(speaker.speakerName, {remove: /[*+~.,()'"!:@]/g})}-${index}` } aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="speaker-block-modal">
                  <div className="speaker-block-modal__header">
                    {speaker.speakerImage &&
                      <div className="speaker-block-modal__img">
                        {speaker.speakerImage?.formats?.large &&
                          <img src={speaker.speakerImage.formats.large.url.includes(cdnUrl) ? speaker.speakerImage.formats.large.url : cdnUrl + speaker.speakerImage.formats.large.url} className="img-circle" alt={ speaker.speakerImage?.alternativeText } />
                        }
                        {!speaker.speakerImage?.formats?.large &&
                          <img src={speaker.speakerImage.url.includes(cdnUrl) ? speaker.speakerImage.url : cdnUrl + speaker.speakerImage.url} className="img-circle" alt={ speaker.speakerImage?.alternativeText } />
                        }
                      </div>
                    }
                    <div className="speaker-block-modal__title-wrap">
                      {speaker.speakerName &&
                        <h3 className="speaker-block-modal__title">{ htmlDecode(speaker.speakerName) }</h3>
                      }
                      {speaker.speakerShortDescription &&
                        <h5 className="speaker-block-modal__subtitle">{ htmlDecode(speaker.speakerShortDescription) }</h5>
                      }
                    </div>
                  </div>
                  {speaker.speakerBio &&
                    <div className="speaker-block-modal__content" dangerouslySetInnerHTML={{ __html: speaker.speakerBio }} />
                  }
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default SummitSpeakersBlock
